export default {"src":"/_next/static/media/proactive-approach.b9a6bd99.svg","height":512,"width":640,"blurWidth":0,"blurHeight":0};